<script setup lang="ts">
import { format } from 'date-fns';
import { type PropType, computed } from 'vue';
import MotionIcon from '../../../icons/MotionIcon.vue';

const props = defineProps({
  value: {
    type: Boolean,
    required: true,
    default: false,
  },
  timestamp: {
    type: Object as PropType<Date>,
    required: true,
  },
});

const formattedTimestamp = computed(() => format(props.timestamp, 'yyyy-MM-dd HH:mm'));
</script>

<template>
  <div class="flex flex-col items-center h-full w-full justify-center">
    <div class="flex flex-1 items-center justify-center ">
      <MotionIcon
        class="text-foreground"
        :class="{ 'animate-spin': !!value }"
      />
    </div>
    <div class="text-foreground/75 text-[14px] leading-[14px]">
      {{ value ? $t('indoorClimate.motion') : $t('indoorClimate.noMotion') }}
    </div>
    <div class="text-foreground/50 text-[9px]">
      {{ formattedTimestamp }}
    </div>
  </div>
</template>

